import moment from 'moment';
import { TOrderDetail, OrderRequestPrepaidDto } from '../types/types';
import { getRefundTypeName } from '../utils/getRefundTypeName';
import { swapPayMethod } from '../utils/texts';
import { PaymentInfoItem } from './PaymentInfoItem';
import { Section } from './Section';

type RefundInfoProps = {
  order: TOrderDetail;
  prepaid: OrderRequestPrepaidDto;
  isMobile: boolean;
};

const RefundInfo = (props: RefundInfoProps) => {
  const { order, prepaid, isMobile } = props;

  const willRefundDate = moment().add(7, 'days').format('YYYY.MM.DD');

  return isMobile ? (
    <>
      <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
        <div className="flex justify-between">
          <p className="">총 반품 금액</p>
          <p className="font-bold">
            {prepaid?.totalPrepayingAmount!.toLocaleString()}원
          </p>
        </div>
        <PaymentInfoItem
          title="반송 비용"
          content={`${prepaid?.deliveryAmount.toLocaleString()}원`}
        />
        <PaymentInfoItem
          title="교환 비용"
          content={`${(
            (prepaid?.totalPrepayingAmount || 0) -
            (prepaid?.deliveryAmount || 0)
          ).toLocaleString()}원`}
        />
      </div>

      {/* TODO 할인정책 나오면 관련 수정 필요 */}
      <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
        <div className="flex justify-between">
          <p className="">총 할인 금액</p>
          <p className="font-bold">-원</p>
        </div>
        <PaymentInfoItem title="쿠폰할인" content={`-원`} />
        <PaymentInfoItem title="적립금" content={`-원`} />
      </div>

      <div className="space-y-2">
        <div className="flex justify-between">
          <p className="">총 환불 금액</p>
          <p className="font-semibold text-red-500">
            {prepaid.totalPaidProductAmount.toLocaleString()}원
          </p>
        </div>
        <PaymentInfoItem
          title="반환 적립금"
          content={`${prepaid.willReturnMileage.toLocaleString()}원`}
        />
        <PaymentInfoItem title="환불 예정일" content={willRefundDate} />
        <PaymentInfoItem
          title="환불처리 "
          content={getRefundTypeName(order.payMethod)}
        />
      </div>
    </>
  ) : (
    <div className="grid grid-cols-3 divide-x-2 border-b">
      <Section className="divide-y-2 pt-4">
        <div className="flex justify-between px-4 pb-4">
          <p className="">총 반품 금액</p>
          <p className="font-semibold">
            {prepaid.totalPrepayingAmount.toLocaleString()}원
          </p>
        </div>

        <div className="space-y-2 p-4">
          <PaymentInfoItem
            title="반송 비용"
            content={`${prepaid.deliveryAmount.toLocaleString()}원`}
          />
          <PaymentInfoItem
            title="교환 비용"
            content={`${(
              prepaid.totalPrepayingAmount - prepaid.deliveryAmount
            ).toLocaleString()}원`}
          />
        </div>
      </Section>

      {/* TODO 할인정책 나오면 관련 수정 필요 */}
      <Section className="divide-y-2 pt-4">
        <div className="flex justify-between px-4 pb-4">
          <p className="">총 할인 금액</p>
          <p className="font-semibold">-원</p>
        </div>

        <div className="space-y-2 p-4">
          <PaymentInfoItem title="쿠폰할인" content={`-원`} />
          <PaymentInfoItem title="적립금" content={`-원`} />
        </div>
      </Section>

      <Section className="divide-y-2 pt-4">
        <div className="flex justify-between px-4 pb-4">
          <p className="">총 환불 금액</p>
          <p className="font-semibold text-red-500">
            {prepaid.totalPaidProductAmount.toLocaleString()}원
          </p>
        </div>
        <div className="space-y-2 p-4">
          <PaymentInfoItem
            title="반환 적립금"
            content={`${prepaid.willReturnMileage.toLocaleString()}원`}
          />
          <PaymentInfoItem title="환불 예정일" content={willRefundDate} />
          <PaymentInfoItem
            title="환불처리"
            content={getRefundTypeName(order.payMethod)}
          />
        </div>
      </Section>
    </div>
  );
};

export default RefundInfo;
